import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const ARBITRUM_TOKEN_TICKERS = [Ticker.USDC, Ticker.USDT]

export type ArbitrumTokenTicker = IterableElement<typeof ARBITRUM_TOKEN_TICKERS>
